"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.FundingRequestComponentConfigSchema = exports.FileInsertionOutputSchema = exports.FileInsertionConfigSchema = exports.PostgresQueryFileInsertionConfigSchema = exports.AthenaQueryFileInsertionConfigSchema = exports.ColumnConfigSchema = exports.TextColumnConfigSchema = exports.PercentageColumnConfigSchema = exports.DateColumnConfigSchema = exports.CurrencyColumnConfigSchema = exports.FileInsertionTypeIterable = void 0;
const _imports_1 = require("../../_imports");
const AthenaConfig_1 = require("../../AthenaConfig");
const CommonPostgresQuery_1 = require("../../CommonPostgresQuery");
const ColumnConfigModule = __importStar(require("../ColumnConfig"));
// *******************************
// ***  File Insertion Config  ***
// *******************************
exports.FileInsertionTypeIterable = [
    'athenaQuery',
    'postgresQuery',
];
// Re-export from shared ColumnConfig namespace
exports.CurrencyColumnConfigSchema = ColumnConfigModule.CurrencyColumnConfigSchema;
exports.DateColumnConfigSchema = ColumnConfigModule.DateColumnConfigSchema;
exports.PercentageColumnConfigSchema = ColumnConfigModule.PercentageColumnConfigSchema;
exports.TextColumnConfigSchema = ColumnConfigModule.TextColumnConfigSchema;
exports.ColumnConfigSchema = ColumnConfigModule.Schema;
// Zod schemas for FileInsertion types
const AbstractFileInsertionConfigSchema = _imports_1.z.object({
    loanProductId: _imports_1.z.string().optional(),
    reportingDateFormula: _imports_1.z.string(),
    columns: _imports_1.z.array(exports.ColumnConfigSchema),
});
exports.AthenaQueryFileInsertionConfigSchema = AbstractFileInsertionConfigSchema.extend({
    fileType: _imports_1.z.literal('athenaQuery'),
    athenaQuery: AthenaConfig_1.QuerySchema,
});
exports.PostgresQueryFileInsertionConfigSchema = AbstractFileInsertionConfigSchema.extend({
    fileType: _imports_1.z.literal('postgresQuery'),
    postgresQuery: CommonPostgresQuery_1.AssetVerificationQuerySchema,
});
exports.FileInsertionConfigSchema = _imports_1.z.discriminatedUnion('fileType', [
    exports.AthenaQueryFileInsertionConfigSchema,
    exports.PostgresQueryFileInsertionConfigSchema,
]);
exports.FileInsertionOutputSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    type: _imports_1.z.literal('fileInsertion'),
    config: exports.FileInsertionConfigSchema,
});
// Compile-time assertion for FileInsertionOutput
// Zod schema for FundingRequestComponentConfig
exports.FundingRequestComponentConfigSchema = _imports_1.z.object({
    collectionsPaydown: _imports_1.z.boolean(),
    collectionsRecycle: _imports_1.z.boolean(),
    curePaydown: _imports_1.z.boolean(),
    drawRequest: _imports_1.z.boolean(),
});
// Zod schema for TemplateConfig (inline to avoid forward reference)
const DocxTemplateConfigSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    s3Path: _imports_1.z.string(),
});
// Zod schema for Docx.Config
exports.ConfigSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    template: DocxTemplateConfigSchema.optional(),
    fundingRequestComponents: exports.FundingRequestComponentConfigSchema.optional(),
    data: _imports_1.z.array(exports.FileInsertionOutputSchema).optional(),
});
// Compile-time assertion for Config
//# sourceMappingURL=Docx.js.map